import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import ManageState from './manageState'
import ModalCustom from '../../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'

type Props = {}

const PollCategories: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        checkPermit
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("หมวดหมู่โพลโหวต")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ตั้งค่า"),
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "complaintSubmit",
                                name: t("หมวดหมู่โพลโหวต"),
                                pathName: routeName.cms_website.PollCategoriesManagement
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหา ชื่อ"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("ช่วงวันที่")
                                    }
                                },
                                {
                                    type: "COMPONENT",
                                    seq: 3,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit.isCreated,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("เพิ่มหมวดหมู่โพลโหวต"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />
                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มหมวดหมู่โพลโหวต") : t("ข้อมูลหมวดหมู่โพลโหวต")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.poll_type,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ชื่อหมวดหมู่โพลโหวต"),
                                            required: true,
                                            value: form.poll_type,
                                            onChange: (e) => set_form((prev) => ({ ...prev, poll_type: e.target.value }))
                                        }
                                    }
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default PollCategories